export type JapanSeason = 'spring' | 'summer' | 'autumn' | 'winter';

export interface SeasonConfig {
  name: string;
  nameJa: string;
  emoji: string;
  description: string;
  accentColor: string;
  gradientFrom: string;
  gradientTo: string;
  bannerText: string;
  events: string[];
  locationTags: string[];
}

const SEASONS: Record<JapanSeason, SeasonConfig> = {
  spring: {
    name: 'Spring',
    nameJa: '\u6625 Haru',
    emoji: '\uD83C\uDF38',
    description: 'Cherry blossom season',
    accentColor: 'pink',
    gradientFrom: '#fce7f3',
    gradientTo: '#fdf2f8',
    bannerText: 'It\'s cherry blossom season! Look for hanami spots near your stops.',
    events: ['Cherry Blossom Viewing (Hanami)', 'Golden Week', 'Sanja Matsuri', 'Wisteria Season'],
    locationTags: ['park', 'garden', 'temple', 'shrine'],
  },
  summer: {
    name: 'Summer',
    nameJa: '\u590F Natsu',
    emoji: '\uD83C\uDF86',
    description: 'Festival and fireworks season',
    accentColor: 'blue',
    gradientFrom: '#dbeafe',
    gradientTo: '#eff6ff',
    bannerText: 'Summer festival season! Don\'t miss the local matsuri and fireworks near your route.',
    events: ['Gion Matsuri', 'Tenjin Matsuri', 'Sumida River Fireworks', 'Obon Festival', 'Nebuta Matsuri'],
    locationTags: ['beach', 'festival', 'mountain', 'island'],
  },
  autumn: {
    name: 'Autumn',
    nameJa: '\u79CB Aki',
    emoji: '\uD83C\uDF41',
    description: 'Fall foliage season',
    accentColor: 'amber',
    gradientFrom: '#fef3c7',
    gradientTo: '#fffbeb',
    bannerText: 'Autumn leaves are at their peak! Temples and gardens are breathtaking right now.',
    events: ['Koyo (Fall Colors)', 'Jidai Matsuri', 'Shichi-Go-San', 'Autumn Illuminations'],
    locationTags: ['temple', 'garden', 'mountain', 'onsen'],
  },
  winter: {
    name: 'Winter',
    nameJa: '\u51AC Fuyu',
    emoji: '\u2744\uFE0F',
    description: 'Illumination and onsen season',
    accentColor: 'cyan',
    gradientFrom: '#ecfeff',
    gradientTo: '#f0f9ff',
    bannerText: 'Winter wonderland! Enjoy illuminations and warm up in an onsen.',
    events: ['Winter Illuminations', 'New Year (Shogatsu)', 'Sapporo Snow Festival', 'Setsubun'],
    locationTags: ['onsen', 'ski', 'illumination', 'shrine'],
  },
};

export function detectSeason(date?: string | Date | null): JapanSeason {
  const d = date ? new Date(date) : new Date();
  const month = d.getMonth() + 1;
  if (month >= 3 && month <= 5) return 'spring';
  if (month >= 6 && month <= 8) return 'summer';
  if (month >= 9 && month <= 11) return 'autumn';
  return 'winter';
}

export function getSeasonConfig(season: JapanSeason): SeasonConfig {
  return SEASONS[season];
}

export function getSeasonForTrip(startDate?: string | null): { season: JapanSeason; config: SeasonConfig } {
  const season = detectSeason(startDate);
  return { season, config: SEASONS[season] };
}
